export type TItem = {
  tabIndex: number
  img?: string
  label: string
  parameters: string
  type: string
  subtype: string
  read: boolean
  timestamp: string
  ucode: string
  uri: string
}

export enum NOTIFICATION_TYPE {
  REQUEST_NOTIFICATION = 'Requesting Notification',
  REQUESTING_NOTIFICATION_AND_TASK_COMPLETED = 'Requesting Notification & Tasks completed',
  PRODUCT_ACTIVATION_AND_ENGAGEMENT = 'Product Activation & Engagement'
}

export enum NOTIFICATION_SUBTYPES {
  PRODUCT_SETUP = 'Product setup',
  USER_PROFILE = 'User Profile'
}
